import type { SVGProps } from 'react';

export function EyeOnIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M2 11.9993C2 11.9993 5.63636 4.72656 12 4.72656C18.3636 4.72656 22 11.9993 22 11.9993C22 11.9993 18.3636 19.272 12 19.272C5.63636 19.272 2 11.9993 2 11.9993Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.27295 12.0007C9.27295 12.724 9.56029 13.4177 10.0717 13.9292C10.5832 14.4406 11.2769 14.728 12.0002 14.728C12.7235 14.728 13.4172 14.4406 13.9287 13.9292C14.4402 13.4177 14.7275 12.724 14.7275 12.0007C14.7275 11.2774 14.4402 10.5837 13.9287 10.0722C13.4172 9.56077 12.7235 9.27344 12.0002 9.27344C11.2769 9.27344 10.5832 9.56077 10.0717 10.0722C9.56029 10.5837 9.27295 11.2774 9.27295 12.0007Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
